import react from 'react'

import { FullPageSpinner } from '../components/FullPageSpinner/FullPageSpinner'
import { useAuth } from '../hooks'

import { AuthorizedAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

export type PartnerScope =
  | 'workplace_giving'
  | 'donation_link'
  | 'volunteering'
  | 'donation_matching'
  | 'donation_wallet'
  | 'gamification'
  | 'payroll_donation'
  | 'giving_campaign'
  | 'giving_ai'
  | 'off_platform_matching'
  | 'content_tags'

export type AuthChecker = (props: { state: AuthorizedAuthState }) => boolean

export const withAuth =
  (...checkers: AuthChecker[]) =>
  (Component: react.ComponentType, OrComponent?: react.ComponentType) =>
    function RolesAuth(props: any) {
      const { state } = useAuth()

      if (state.status === 'loading' || state.status === 'first_load' || state.status === 'unauthorized') {
        return <FullPageSpinner />
      }

      if (state.status === 'authorized' && checkers.every(checker => checker({ state }))) {
        return <Component {...props} />
      }

      if (OrComponent) {
        return <OrComponent {...props} />
      }

      return null
    }

export const permission =
  (...allowedPermissions: string[]): AuthChecker =>
  ({ state }) =>
    allowedPermissions.some(p => state.permissions.includes(p))

export const scope =
  (...requiredScopes: PartnerScope[]): AuthChecker =>
  ({ state }) =>
    requiredScopes.every(s => state.partner?.scopes.map(({ scopeName }) => scopeName).includes(s))

export const withWorkplaceGivingAccess = withAuth(permission('wg_dashboard:access'), scope('workplace_giving'))
